export const Pagination = (props: any) => {
  return (
    <div>
      {props.limit &&
        props.limit > 0 &&
        props.pageSize &&
        props.pageSize.length > 0 && (
          <div className="flex justify-end m-4">
            <input
              type="number"
              className="px-2"
              min={1}
              defaultValue={props.limit}
              onChange={(e) => props.changeLimit(e)}
            />
            {props.pageNumber > 0 && (
              <button
                className="px-2"
                onClick={() => props.paginationChange("previous")}
              >
                Previous
              </button>
            )}
            {props.hasMore && (
              <button
                className="px-2"
                onClick={() => props.paginationChange("next")}
              >
                Next
              </button>
            )}
          </div>
        )}
    </div>
  );
};
